import flat from 'flat'

export const flatten = (
    obj: Record<string, any>
): {
    [key: string]: string
} => flat(obj)
